export const CHAT_SESSION_KEY = 'craft_chat_session_id'

/** True when this browser already has a live chat session (localStorage or cookie). */
export function hasStoredChatSession(): boolean {
  try {
    if (localStorage.getItem(CHAT_SESSION_KEY)) return true
  } catch {
    // Storage blocked: fall through to the cookie
  }
  return document.cookie.includes(`${CHAT_SESSION_KEY}=`)
}
